<template>
    <div>
      <Header/>
      <main>
        <slot/>
      </main>
      <Footer/>
    </div>
</template>